import { useMutation } from "@tanstack/react-query";

import { useAuthStore } from "../../auth/store";
import {
  registerUser,
  type AuthCredentialsRequest,
  type AuthTokenResponse,
} from "./api";

// Хук формы регистрации. Register сразу создаёт серверную сессию и
// ставит HttpOnly cookie `baton_session` (#916), поэтому «авто-логин»
// — это `login(identity)` в `onSuccess` (записываем только
// identity-флаг, токен в JS не держим). Никаких дополнительных
// POST /auth/login не нужно.
export function useRegister(): ReturnType<
  typeof useMutation<AuthTokenResponse, Error, AuthCredentialsRequest>
> {
  return useMutation<AuthTokenResponse, Error, AuthCredentialsRequest>({
    mutationFn: (creds) => registerUser(creds),
    onSuccess: (data) => {
      // Не подписываемся через selector — нужен разовый dispatch
      // action'а, без ре-рендера компонента после `set`.
      //
      // Сессия входа org-less по ADR-0038 (§2): `data.org_id` —
      // хинт, не грант, и намеренно не используется. Активную
      // организацию ставит только `switchOrganization` (см.
      // `useSwitchOrganization`) или сверка с `GET /me` в
      // `RequireActiveOrg`.
      useAuthStore.getState().login({ userId: data.user_id, orgId: null });
    },
  });
}
